import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

const LoadingIndicator = ({ className }) => {
  return <div className={cn('loading-indicator', className)}></div>;
};

LoadingIndicator.propTypes = {
  className: PropTypes.string,
};

LoadingIndicator.viewModelMeta = 'ignore';

export default LoadingIndicator;
